<template>
  <article class="event-gallery">
    <div class="gallery-container">
      <template
        v-for="(item, index) in photos"
        :key="item.id"
      >
        <PhotoGalleryItem
          :class="photos.length < 2 ? 'max-w-[400px]' : ''"
          :photo="item"
          :is-photo-in-cart="isPhotoInCart(item.ulid)"
          @click="selectedPhoto = item"
        />
        <PhotoPackGalleryItem
          v-if="index === 2 && photos.length >= 8 && !selectedCategory && props.event.canPurchaseBulkPhotos"
          v-model:bib-number-search="gallerySearchParams.search"
          :previous-photo="photos[index - 1]"
          :searched-bib-number="searchedBibNumber"
          :show-buy-photo-pack="showBuyPhotoPack"
          :photo-pack-price="photoPackPrice"
          :photos-count="photoPackCount"
          :is-photo-pack-in-cart="isPackInCart(searchedBibNumber)"
          :adding-pack-to-cart="addingPackToCart"
          @add-to-cart="handleAddPackToCart"
          @search="() => {
            $emit('search', gallerySearchParams);
            gallerySearchParams.search = null;
          }"
        />
      </template>
    </div>

    <PhotoModal
      v-if="selectedPhoto"
      :adding-photo-to-cart="addingPhotoToCart"
      :adding-pack-to-cart="addingPackToCart"
      :photo="selectedPhoto"
      :event="event"
      :photo-pack-price="photoPackPrice"
      :searched-bib-number="searchedBibNumber"
      :number-of-photos="photoPackCount"
      @add-to-cart-clicked="handleAddPhotoToCart"
      @add-pack-to-cart-clicked="handleAddPackToCart"
      @close="selectedPhoto = null"
      @transition-main-photo-modal="transitionMainPhotoModal = true"
    />
  </article>
</template>

<script setup>
import { computed, reactive, ref } from 'vue';

import { PhotoGalleryItem, PhotoPackGalleryItem } from '@/components/galleries';
import { PhotoModal } from '@/components/modals';

import { DeliveryType, DigitalSize, PhotoType, StyleType } from '@/const';
import { useCartStore } from '@/store';

defineEmits(['search']);

const props = defineProps({
  photos: {
    type: Array,
    default: () => [],
  },
  searchedBibNumber: {
    type: Number,
    default: null,
  },
  selectedCategory: {
    type: Number,
    default: null,
  },
  event: Object,
  price: Number,
  photoPackCount: Number,
});

const transitionMainPhotoModal = ref(false);
const showBuyPhotoPack = computed(() => {
  return !props.searchedBibNumber || isPackInCart(props.searchedBibNumber);
});

const gallerySearchParams = ref({
  cursor: null,
  search: null,
  searchBy: 'bibNumber',
  category: null,
});

const orderItem = reactive({
  style: StyleType.Event,
  delivery: DeliveryType.Digital,
  size: DigitalSize.Standard,
  quantity: 1,
  bibNumber: null,
  event: props.event.id,
  photo: null,
});

const selectedPhoto = ref(null);
const addingPhotoToCart = ref(false);
const addingPackToCart = ref(false);
const cartStore = useCartStore();

const handleAddPhotoToCart = async (data) => {
  addingPhotoToCart.value = true;

  orderItem.bibNumber = null;
  orderItem.photo = data.photo;

  await cartStore.addItem(orderItem);
  addingPhotoToCart.value = false;
};

const handleAddPackToCart = async () => {
  addingPackToCart.value = true;

  orderItem.photo = null;
  orderItem.bibNumber = props.searchedBibNumber;

  await cartStore.addItem(orderItem);

  selectedPhoto.value = false;
  addingPackToCart.value = false;
};

const isPhotoInCart = (ulid) => {
  return cartStore.cart?.items?.some(order => order.photo?.ulid === ulid && order.type === PhotoType.Single);
};

const isPackInCart = (bibNumber) => {
  return cartStore.cart?.items?.some(order => order.bibNumber === bibNumber && order.type === PhotoType.Pack);
};

const photoPackPrice = computed(() => {
  return props.event.prices.find(price => price.type === PhotoType.Pack).price;
});

</script>
